import { HTMLInputTypeAttribute } from 'react';
import { Label, TextInput } from '@c2fo/liquidity';
import { LendingFormConfig } from './types';
import useLendingFormContext from './useLendingFormContext';

const FormInput = ({
  name,
  label,
  type,
}: {
  name: keyof LendingFormConfig['contact'];
  label: string;
  type?: HTMLInputTypeAttribute;
}) => {
  const {
    register,
    formState: { errors },
    clearErrors,
  } = useLendingFormContext();
  const error = errors.contact?.[name];

  return (
    <span className="w-full">
      <Label htmlFor={name} required>
        {label}
      </Label>
      <div className="flex items-center gap-2">
        {name === 'annualRevenue' && <span>$</span>}
        <TextInput
          id={name}
          className="w-full"
          hasError={!!error}
          {...register(`contact.${name}`, {
            required: 'Required',
            onChange: () => {
              clearErrors(`contact.${name}`);
            },
          })}
          type={type}
          aria-label={name}
        />
        {name === 'annualRevenue' && <span>USD</span>}
      </div>
      {name === 'customers' && (
        <span className="text-sm text-text-secondary">
          Enter a few of your top customers to help us understand your business better.
        </span>
      )}
      {error?.type === 'required' && <p className="text-sm text-red-500">{error.message}</p>}
    </span>
  );
};

const ContactStep = () => {
  return (
    <div>
      <div className="mt-4 flex flex-col space-y-4 rounded bg-gray-50 p-4">
        {/* Name input */}
        <FormInput name="name" label="Full Name" />
        <div className="flex flex-col gap-4 sm:flex-row sm:gap-2">
          {/* Job Title input */}
          <FormInput name="jobTitle" label="Title" />
          {/* Phone number input */}
          <FormInput name="phoneNumber" label="Phone Number" type="tel" />
        </div>
        {/* Email input */}
        <FormInput name="email" label="Email" type="email" />
      </div>
      <div className="mt-4 flex flex-col space-y-4 rounded bg-gray-50 p-4">
        {/* Company Name input */}
        <FormInput name="company" label="Company Name" />
        {/* Annual Revenue input */}
        <FormInput name="annualRevenue" label="Annual Revenue" type="number" />
        {/* Customers input */}
        <FormInput name="customers" label="Customers" />
      </div>
    </div>
  );
};

export default ContactStep;
